<br>
<div class="container-fluid h-100">
  <div class="row h-100">
    <div class="col section-content">
      <div class="content-container">
        <div class="icon-circle">
          <i class="bi bi-box-arrow-in-left">
          </i>
        </div>
        <app-st-header-title [inputVal]="'Reset Password Link Sent'"></app-st-header-title>
        <br>
        <app-st-span [inputVal]="'Check your email ' + this.username + ' for your password reset link.'"></app-st-span>
        <br><br>
        <app-st-span [inputVal]="'Click here if you are not directed.'"></app-st-span>
        <br><br>
        <app-st-button [label]="'Login'" [primary]="true" (onClick)="onGoToLogin()"></app-st-button>
      </div>
    </div>
  </div>
</div>
